import React, { useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";
import { clearStoredSelectedDoctorId } from "helpers/doctorSelection";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const ref = useRef();
  const navigate = useNavigate();
  const Infuseonerolename = localStorage.getItem("Infuseonerolename");
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const handleLogout = async (e) => {
    clearStoredSelectedDoctorId();
    localStorage.removeItem("InfuseoneUserToken");
    localStorage.removeItem("Infuseonerolename");
    localStorage.removeItem("Infuseoneuserinfo");
    navigate("/");
  }

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {/* <li className="menu-title">{props.t("Menu")} </li> */}
            {Infuseonerolename === "Admin" ? (
              <>
                <li>
                  <Link to="/dashboard" className=" ">
                    <i className="bx bx-home-circle"></i>
                    <span>{props.t("Home")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/drug-list" >
                    <i className='bx bx-list-ul'></i>
                    <span>{props.t("Drug")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/user-verification" >
                    <i className="bx bx-user-check"></i>
                    <span>{props.t("User Verification")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/user-list" >
                    <i className="mdi mdi-account-group-outline"></i>
                    <span>{props.t("Users")}</span>
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to="/dashboard" className=" ">
                    <i className="bx bx-home-circle"></i>
                    <span>{props.t("Home")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/appointments" >
                    <i className="bx bx-calendar"></i>
                    <span>{props.t("Appointments")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/patients" >
                    <i className="bx bx-user"></i>
                    <span>{props.t("Patients")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/assgined-user-drug-list" >
                    <i className='bx bx-list-ul'></i>
                    <span>{props.t("Drug List")}</span>
                  </Link>
                </li>
              </>
            )
            }
            <li>
              <Link to="/user-profile" className=" ">
                <i className="mdi mdi-account"></i>
                <span>{props.t("Profile")}</span>
              </Link>
            </li>
            <li>
              <Link to="/change-password" className=" ">
                <i className="bx bx-key"></i>
                <span>{props.t("Change Password")}</span>
              </Link>
            </li>

            <li>
              <Link to="#" className=" " onClick={handleLogout}>
                <i className="bx bx-power-off"></i>
                <span>{props.t("Logout")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
